<template>
  <v-form ref="form" v-model="form">
    <v-layout row>
      <v-text-field
        :label="nomeDoCampo"
        v-model="dataFormatada"
        mask="##/##/####"
        placeholder="dd/mm/aaaa"
        :rules="regras"
        @blur="salvarDataDigitada(dataFormatada)"
        :readonly="ehEditavel"
        :disabled="desabilitado"
      ></v-text-field>

      <v-menu
        ref="menu"
        v-model="dialogSeletorDeData"
        :close-on-content-click="false"
        transition="scale-transition"
        min-width="290px"
        offset-y
        class="pt-4"
      >
        <v-icon slot="activator">event</v-icon>
        <v-date-picker
          v-model="dataSelecionada"
          no-title
          locale="pt-br"
          :min="dataMinima"
          :max="dataMaxima"
        >
          <v-btn flat color="primary" @click="dialogSeletorDeData = false"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            flat
            color="primary"
            class="pl-5"
            @click="salvarDataSelecionada(dataSelecionada)"
            >OK</v-btn
          >
        </v-date-picker>
      </v-menu>
    </v-layout>
  </v-form>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      dataFormatada: "",
      dataSelecionada: "",
      dialogSeletorDeData: false,
      form: false
    };
  },
  props: {
    nomeDoCampo: {
      type: String,
      default: "",
    },
    dataMinima: {
      default: "",
    },
    regras: {
      default: [],
    },
    data: {
      type: String,
    },
    dataMaxima: {
      default: "",
    },
    ehEditavel: {
      type: Boolean,
      default: false
    },
    desabilitado: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatarData(data, formato) {
      return moment(data).format(formato);
    },
    salvarDataSelecionada(dataSelecionada) {
      this.dialogSeletorDeData = false;
      this.dataFormatada = this.formatarData(dataSelecionada, "DD/MM/YYYY");
      this.$refs.form.resetValidation();
      this.$emit("pegarData", dataSelecionada);
      this.$emit("validacaoFormulario", this.$refs.form.validate());
    },
    salvarDataDigitada(dataDigitada) {
      if (dataDigitada.length == 8 || dataDigitada.length == 10) {
        if (this.verificarSeDataEhValida(dataDigitada)) {
          let dataConvertidaParaObjeto = moment(dataDigitada, "DDMMYYYY");
          let dataValidada = this.verificarSeDataEhMaiorQueMinima(
            dataConvertidaParaObjeto
          );
          dataValidada = this.verificarSeDataEhMenorQueMaxima(dataValidada);
          let dataFormatadaEmBr = this.formatarData(dataValidada, "DD/MM/YYYY");
          let dataFormatadaEmUs = this.formatarData(dataValidada, "YYYY-MM-DD");
          this.dataFormatada = dataFormatadaEmBr;
          this.dataSelecionada = dataFormatadaEmUs;
          this.$emit("pegarData", dataFormatadaEmUs);
        } else {
          this.dataFormatada = "";
          this.dataSelecionada = "";
          this.$emit("pegarData", "");
        }
      }else {
        this.dataFormatada = "";
        this.dataSelecionada = "";
        this.$emit("pegarData", "");
      }
    },
    verificarSeDataEhMaiorQueMinima(data) {
      if (this.validarSeTemDataMinima) {
        if (moment(data).isSameOrAfter(this.dataMinima)) return data;
        else return moment(this.dataMinima, "YYYYMMDD");
      } else return data;
    },
    verificarSeDataEhMenorQueMaxima(data) {
      if (this.validarSeTemDataMaxima) {
        if (moment(data).isSameOrBefore(this.dataMaxima)) return data;
        else return moment(this.dataMaxima, "YYYYMMDD");
      } else return data;
    },
    verificarSeDataEhValida(data) {
      return moment(data, "DDMMYYYY").isValid();
    },
  },
  computed: {
    validarSeTemDataMinima() {
      return this.dataMinima != "";
    },
    validarSeTemDataMaxima() {
      return this.dataMaxima != "";
    },
  },
  watch: {
    data(data) {
      this.dataFormatada = this.formatarData(data, "DD/MM/YYYY");
    },
    form(formValidado){
      this.$emit("validacaoFormulario", formValidado)
    }
  },
  created() {
    this.dataFormatada = this.formatarData(this.data, "DD/MM/YYYY");
    this.dataSelecionada = this.data;
    this.$emit("validacaoFormulario", this.form)
  },
};
</script>

<style>
</style>